import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { initializeVisitorIdentity, collectClientMetadata } from './services/identity';
import { apiService, sendHeadsup } from './services/api';
import { storageService } from './services/storage';

// Initialize visitor identity (always happens, independent of Clarity and tracking)
const visitorIdentity = initializeVisitorIdentity();

// Check if user is admin (respect privacy like we do with Clarity)
const isAdmin = localStorage.getItem('admin-pass');

// Track visit to our own system (backup tracking)
if (visitorIdentity?.id && !isAdmin) {
    // Track the visit asynchronously (non-blocking)
    const metadata = collectClientMetadata();
    apiService.trackVisit(visitorIdentity.id, metadata || undefined)
        .then(() => {
            console.log('[Visit Tracker] Visit recorded');
        })
        .catch((error) => {
            console.error('[Visit Tracker] Failed to record visit:', error);
        });
} else if (isAdmin) {
    console.log('[Visit Tracker] Admin detected, skipping visit tracking');
}

// Send headsup notification for returning users (users with saved customer info)
if (!isAdmin) {
    try {
        const savedCustomer = storageService.getCustomer();
        if (savedCustomer && (savedCustomer.name || savedCustomer.address)) {
            sendHeadsup({
                eventType: 'returning_user',
                customerName: savedCustomer.name || undefined,
                customerAddress: savedCustomer.address || undefined,
            });
            console.log('[Headsup] Returning user detected, notification sent');
        }
    } catch (error) {
        // Silently ignore - headsup is non-critical
        console.log('[Headsup] Error checking returning user, continuing...', error);
    }
}

// Send visitor ID to Microsoft Clarity if it's loaded and conditions are met
if (visitorIdentity?.id) {
    const isProduction = window.location.hostname === 'delifeed.com' || window.location.hostname === 'www.delifeed.com';

    // Only identify to Clarity on production and for non-admin users
    if (isProduction && !isAdmin && typeof window.clarity === 'function') {
        try {
            window.clarity('identify', visitorIdentity.id);
            console.log('[Clarity] User identified:', visitorIdentity.id);
        } catch (error) {
            console.error('[Clarity] Failed to identify user:', error);
        }
    } else if (isAdmin) {
        console.log('[Clarity] Admin detected, skipping Clarity identification');
    }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>,
);
